import React from "react";
import { Flex } from "rebass/styled-components";
import styled from "styled-components";

/*  Our LOCAL component imports */
import { Chevron, StudioIcon } from "../../../../Components/StudioIcons";

/*  Our GLOBAL component imports */

export default function FacetPills({ identifier, item, onQuery, query }: any) {
  const checked = Boolean(query[identifier]?.includes(item.label));

  return (
    <StyledCheckboxFlex
      m={2}
      alignItems="center"
      checked={checked}
      flexShrink={1}
      onClick={() => {
        onQuery(!checked, identifier, item.label);
      }}
    >
      <Flex>
        <Flex ml={1} flexShrink={0} alignItems="center">
          <StudioIcon type={item.label} size={16} />
        </Flex>
        <StyledLabelText checked={checked}>{item.label}</StyledLabelText>
      </Flex>

      {/* <StyledSubheader checked={checked} alignSelf="flex-end">
        {facetLoading ? (
          <LoadingSkeleton
            color={"#191F27"}
            style={{ borderRadius: "2px" }}
            height={14}
            width={13}
          />
        ) : (
          `${item.count}`
        )}
      </StyledSubheader> */}
    </StyledCheckboxFlex>
  );
}

const StyledCheckboxFlex = styled(Flex)`
  background-color: ${(props: any) =>
    props.checked
      ? props.theme.colors.midnightAlpha50
      : props.theme.colors.darkerNed};
  padding: 4px 12px;
  border-radius: 999px;
  border: 2px solid;
  border-color: ${(props: any) =>
    props.checked
      ? props.theme.colors.turboAlpha20
      : props.theme.colors.darkerNed};
  &:hover {
    color: ${(props: any) => props.theme.colors.ice};
    background-color: ${(props: any) => props.theme.colors.midnightAlpha50};
    border-color: #293944;
  }
  &:hover ${Chevron} {
    color: ${(props: any) => props.theme.colors.envy};
  }
`;

const StyledLabelText = styled.span<any>`
  font-weight: ${(props: any) => (props.checked ? 500 : 500)};
  font-size: ${(props: any) => (props.checked ? "14px" : "14px")};
  color: ${(props: any) => (props.checked ? props.theme.colors.ice : null)};
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0px 1px;
  line-height: 1.9em;
`;

// const StyledSubheader = styled(Subheader)`
//   font-weight: ${(props: any) => (props.checked ? 500 : 500)};
//   font-size: ${(props: any) =>
//     props.checked ? props.theme.text.footnote.fontSize : props.theme.text.footnote.fontSize};
//   color: ${(props: any) => (props.checked ? props.theme.colors.ice : null)};
//   padding: 2px 10px;
//   border-radius: ${(props: any) => (props.checked ? "14px" : null)};
//   line-height: 1.6em;
//   text-overflow: ellipsis;
//   white-space: nowrap;
// `;
